import {HIDE_ALERT} from "../../../constants/ExtraConstants";
import {GeneralAction, HideExtraPayload} from "../../../@types/actions";

export const HideAlertAction = (data: HideExtraPayload): GeneralAction<HideExtraPayload> => ({
    type: HIDE_ALERT,
    payload: data
});
